import type { TableTheme } from '../../types';

export const defaultColors: TableTheme['colors'] = {
  primary: { main: '#1976d2', light: '#42a5f5', contrastText: '#fff' },
  secondary: { main: '#9c27b0', light: '#ba68c8', contrastText: '#fff' },
  blocked: { main: '#f44336', light: '#f26257', contrastText: '#fff' },
  background: '#ffffff',
  text: 'inherit',
  border: '#777',
  borderLight: '#eee',
};
